function urlBase64ToUint8Array(base64String: string): Uint8Array {
  // Pad the string with '=' if needed
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+") // Replace '-' with '+'
    .replace(/_/g, "/"); // Replace '_' with '/'

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function setupNotification(userId, restaurantId, swRegistration) {
  if (!("serviceWorker" in navigator)) return;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return;

  // const swRegistration = await navigator.serviceWorker.register(
  //   "/service-worker.js"
  // );
  const existingSub = await swRegistration.pushManager.getSubscription();

  if (existingSub) {
    console.log("Subscription already exists, skipping new creation.");
    return;
  }

  const tempKey =
    "BEFkY1y5ZUjLhgrsJ5u9Jir9NdYz7nMD_2FpmxA4c3oTIU_CchfXEUpGn8MIxQASyOJFNoLffz_kwn8-tjOd1yw";

  console.log(
    "REACT_APP_VAPID_PUBLIC_KEY:",
    process.env.REACT_APP_VAPID_PUBLIC_KEY
  );

  console.log(
    "REACT_APP_VAPID_PUBLIC_KEY after urlBase64ToUint8Array called:",
    urlBase64ToUint8Array(process.env.REACT_APP_VAPID_PUBLIC_KEY)
  );
  const rawSubscription = await swRegistration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(
      process.env.REACT_APP_VAPID_PUBLIC_KEY
    ),
  });

  const subscription = {
    endpoint: rawSubscription.endpoint,
    p256dh: btoa(
      String.fromCharCode.apply(
        null,
        new Uint8Array(rawSubscription.getKey("p256dh"))
      )
    ),
    auth: btoa(
      String.fromCharCode.apply(
        null,
        new Uint8Array(rawSubscription.getKey("auth"))
      )
    ),
  };

  await fetch(`${process.env.REACT_APP_SECRET}/api/PWA/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      subscription,
      userId,
      restaurantId,
    }),
  });
}

export async function waitForServiceWorker() {
  let registration = navigator.serviceWorker.controller;

  while (!registration) {
    console.log("Waiting for service worker to be ready...");
    await new Promise((resolve) => setTimeout(resolve, 1000));
    registration = navigator.serviceWorker.controller;
  }

  return await navigator.serviceWorker.ready;
}
